<template>
    <div class="activity-list-view" ref="activityiesListView">
        <a-spin :spinning="loading">
            <template v-if="activities.length > 0">
                <div class="date-group" :key="date" v-for="date of Object.keys(groups())">
                    <div class="date">{{ $moment(date, "YYYY-MM-DD").format("LL") }}</div>
                    <div class="activity-cards">
                        <ActivityCard :activity="activity" :key="activity._id" v-for="activity of groups()[date]" />
                    </div>
                </div>
            </template>
            <div class="empty-activities" v-else>
                <div class="material-icons notification-shake">notifications_active</div>
                <div class="empty-message-title">{{ $t('notification.noActivityTitle') }}</div>
                <div class="empty-message">
                    {{ $t('notification.noActivityDesc') }}
                </div>
            </div>
        </a-spin>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _ from "lodash";
import ActivityCard from "./ActivityCard.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ActivityListView",
    components: { ActivityCard, SupsisButton },
    props: {
        activities: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            groupByDate: true,
            listeners: [],
            moment,
        };
    },
    methods: {
        groups() {
            const groups = {};
            const orderedItems = _.orderBy(this.activities, ["createdAt"], ["desc"]);
            orderedItems.forEach((activity) => {
                const date = moment(this.groupByDate ? activity.createdAt : undefined).format("YYYY-MM-DD");
                if (!groups[date]) {
                    groups[date] = [];
                }
                groups[date].push(activity);
            });
            return groups;
        },
        checkScrollAndLoad() {
            const activityiesListView = this.$refs.activityiesListView;
            if (!activityiesListView) return;

            const scrollHeight = activityiesListView.offsetHeight + activityiesListView.scrollTop;
            const totalHeight = activityiesListView.scrollHeight;
            const hasScroll = totalHeight > activityiesListView.offsetHeight;
            
            // Eğer scroll yoksa veya scroll sonuna yakınsa yükle
            if (!hasScroll || scrollHeight + 0.5 >= totalHeight) {
                this.$emit("load-more");
            }
        },
        handleResize() {
            // Resize olduğunda scroll pozisyonunu kontrol et
            this.$nextTick(() => {
                this.checkScrollAndLoad();
            });
        },
    },
    mounted() {
        const activityiesListView = this.$refs.activityiesListView;
        
        // Scroll listener
        const scrollListener = () => {
            this.checkScrollAndLoad();
        };
        this.listeners.push(() => activityiesListView?.removeEventListener("scroll", scrollListener));
        activityiesListView?.addEventListener("scroll", scrollListener);
        
        // Window resize listener (debounced)
        const debouncedResize = _.debounce(() => {
            this.handleResize();
        }, 300);
        window.addEventListener("resize", debouncedResize);
        this.listeners.push(() => window.removeEventListener("resize", debouncedResize));
        
        // İlk yüklemede scroll kontrolü yap
        this.$nextTick(() => {
            this.checkScrollAndLoad();
        });
    },
    watch: {
        activities: {
            handler() {
                // Activities değiştiğinde scroll kontrolü yap
                this.$nextTick(() => {
                    this.checkScrollAndLoad();
                });
            },
            deep: false,
        },
    },
    beforeDestroy() {
        this.listeners.map((fn) => fn());
    },
});
</script>

<style scoped lang="scss">
.activity-list-view {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: calc(100vh - 157px);
    overflow: auto;
    .empty-activities {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 20px 0px;
        gap: 10px;
        user-select: none;
        .empty-message-title {
            font-weight: bold;
            font-size: 20px;
        }
        .empty-message {
            font-size: 14px;
            font-weight: 400;
        }
        .notification-shake {
            font-weight: bold;
            font-size: 48px;
        }
    }
    .hidden-groups {
        .date {
            display: none;
        }
    }

    .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        font-size: 18px;
        font-weight: 600;
        color: var(--color-text-default);
        padding: 20px;

        .icon {
            .MuiSvgIcon-root {
                width: 50px;
                height: 50px;
            }
        }
    }

    .date-group {
        .date {
            position: relative;
            display: inline;

            &:after {
                position: absolute;
                left: 50%;
                bottom: -15px;
                height: 12px;
                width: 1px;
                content: "";
                background: var(--color-border-default);
            }
        }

        .activity-cards {
            display: flex;
            flex-direction: column;
            border: 1px solid var(--color-border-default);
            border-radius: 4px;
            margin-top: 11px;

            .activity-card:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>
